export default function TravelodgeFormCheckerFactory(
    l10nService,
    userService,
    authService,
    HOTELS_SUPPLIERS
) {
    'ngInject';

            const regionalSettings = userService.getRegionalSettings();
            const isTravelodgeEnabled = authService.isSupplierEnabled(HOTELS_SUPPLIERS.TRAVEL_LODGE);

            if (!isTravelodgeEnabled) {
                return [];
            }

            return [
                {
                    propertyName: 'options.roomsListSelected.value',
                    needToShowMessage(property) {
                        if (!property) {
                            return true;
                        }
                        return +property < 10;
                    },
                    message: l10nService.localize('For Travelodge bookings exceeding 9 rooms please contact your reservations team'),
                },
                {
                    propertyName: 'params',
                    needToShowMessage(params) {
                        if (!params.checkInDate || !params.checkOutDate) {
                            return true;
                        }
                        return moment(params.checkOutDate, regionalSettings.dateFormat).diff(
                                moment(params.checkInDate, regionalSettings.dateFormat), 'days') < 15;
                    },
                    message: l10nService.localize('For Travelodge bookings exceeding 14 nights please contact your reservations team'),
                },
            ];
}



// WEBPACK FOOTER //
// ./src/app/modules/hotels/services/travelodgeFormChecker.js